enum GroupLevel {
    User = 0,
    Group = 1,
    Site = 2,
}

export default GroupLevel;
